export var FLOAT = /^\d*\.?\d*$/;